/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountBalanceApiModel } from '../../models/account-balance-api-model';
import { AdminAddFundsToUserRequestApiModel } from '../../models/admin-add-funds-to-user-request-api-model';

export interface AddFunds$Params {
      body: AdminAddFundsToUserRequestApiModel
}

export function addFunds(http: HttpClient, rootUrl: string, params: AddFunds$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountBalanceApiModel>> {
  const rb = new RequestBuilder(rootUrl, addFunds.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccountBalanceApiModel>;
    })
  );
}

addFunds.PATH = '/admin/funds/add';
